import { DatabaseOnboardingType } from '@baserow/modules/database/onboardingTypes'
import SubscriptionService from '@saas/services/subscriptions'

export class SaaSWorkspaceOnboardingType extends DatabaseOnboardingType {
  async complete(data, responses, callback) {
    const result = await super.complete(data, responses, callback)
    const workspace = result.workspace
    await SubscriptionService(this.app.$client).startTrial(workspace.id)
    // This fetches the active licenses again, so that the user immediately has access
    // to free trial features.
    await this.app.$store.dispatch('auth/refresh')
    await this.app.$store.dispatch('saasApp/setShowFreeTrialStep', true)
    return result
  }
}
